import { getActivityUrl } from "lib/util";
import { Fragment } from "react";

export const Breadcrumb = ({ item }: { item: Travelguide.OOI }) => {
  if (!item.category.activity) {
    return null;
  }
  const navItems = [
    {
      label: item.category.activity.title,
      url: getActivityUrl(item.category.activity),
    },
    {
      label: item.category.name,
    },
  ];
  return (
    <nav className="flex flex-row gap-2 list-none px-4 md:px-6">
      {navItems.map(({ label, url }, i, all) => (
        <Fragment key={i}>
          <li className="inline">{url ? <a href={url}>{label}</a> : label}</li>
          {i < all.length - 1 && ">"}
        </Fragment>
      ))}
    </nav>
  );
};
